var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-list',{attrs:{"subheader":""}})],1),_c('v-flex',{attrs:{"xs8":""}},[_c('div',{attrs:{"id":"drawflow"},on:{"drop":_vm.drop,"dragover":_vm.allowDrop}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }